"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactI18next = require("react-i18next");
var _Card = _interopRequireDefault(require("../Card"));
var _eventDispatcher = _interopRequireWildcard(require("../../util/eventDispatcher"));
var _popupSlice = require("../../redux/popupSlice");
var _store = require("../../redux/store");
var _Payment = require("./Payment.const");
var _PaymentCardStyled = require("./PaymentCardStyled");
var _visuallyHidden = _interopRequireDefault(require("../../styles/visuallyHidden"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PaymentCard = _ref => {
  let {
    details
  } = _ref;
  const dispatch = (0, _store.useAppDispatch)();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    paymentMethodSpecificParams,
    paymentMethod
  } = details;
  const getSpecificPaymentMethod = () => {
    if (paymentMethod === 'card') return paymentMethodSpecificParams.variant;
    return paymentMethod;
  };
  const card = _Payment.CardTypes[getSpecificPaymentMethod()];
  const LogoComponent = (card === null || card === void 0 ? void 0 : card.icon) || null;
  const logoCaption = card === null || card === void 0 ? void 0 : card.caption;
  const methodTitle = (card === null || card === void 0 ? void 0 : card.title) || '';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Card.default, {
    withBorder: true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentCardStyled.CardStyled, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PaymentCardStyled.CardInfoWrapStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_PaymentCardStyled.CardInfoStyled, {
          children: [LogoComponent && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PaymentCardStyled.CardTypeStyled, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(LogoComponent, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_visuallyHidden.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("figcaption", {
              className: "visually-hidden",
              children: logoCaption
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PaymentCardStyled.CardDetailsStyled, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_PaymentCardStyled.CardDetailsNameWrapStyled, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentCardStyled.CardDetailsNameStyled, {
                children: methodTitle
              }), paymentMethod !== 'paypal' && (paymentMethodSpecificParams === null || paymentMethodSpecificParams === void 0 ? void 0 : paymentMethodSpecificParams.lastCardFourDigits) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PaymentCardStyled.CardNumberStyled, {
                children: ["(**** ", paymentMethodSpecificParams.lastCardFourDigits, ")"]
              })]
            }), paymentMethod === 'paypal' && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PaymentCardStyled.HolderNameStyled, {
              children: ["(", paymentMethodSpecificParams.holderName, ")"]
            }), paymentMethod !== 'paypal' && (paymentMethodSpecificParams === null || paymentMethodSpecificParams === void 0 ? void 0 : paymentMethodSpecificParams.cardExpirationDate) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PaymentCardStyled.CardExpirationStyled, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentCardStyled.CardExpirationLabel, {
                children: t('paymentcard.expiry-date', 'Expiry date')
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentCardStyled.CardExpirationDateStyled, {
                dateTime: paymentMethodSpecificParams.cardExpirationDate,
                children: paymentMethodSpecificParams.cardExpirationDate
              })]
            })]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentCardStyled.CardEditStyled, {
          type: "button",
          onClick: () => {
            dispatch((0, _popupSlice.updatePaymentDetailsPopup)({
              isOpen: true,
              initPaymentMethod: details
            }));
            (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_EDIT_PAYMENT_BUTTON_CLICKED, {
              detail: {
                paymentMethod
              }
            });
          },
          children: t('paymentcard.edit-payment-info', 'Edit payment info')
        })]
      })
    })
  });
};
var _default = exports.default = PaymentCard;